export const defaultRelevenceParams = {
    'page-index': 1,
    relevence: 'match',
    // 'selected_addr': []
}